'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of supp bottle
 */ const SuppBottle = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M64.0352 48.1692V43.4233H65.6635C66.6513 43.4233 67.452 42.6226 67.452 41.6348V36.228C67.452 35.2402 66.6513 34.4395 65.6635 34.4395H37.9276C36.9399 34.4395 36.1391 35.2402 36.1391 36.228V41.6348C36.1391 42.6226 36.9399 43.4233 37.9276 43.4233H39.5559V48.2392C37.681 48.924 36.0642 50.1557 34.9224 51.7691C33.7805 53.3825 33.1684 55.3004 33.168 57.2654V89.7092C33.168 90.697 33.9687 91.4977 34.9565 91.4977H68.8412C69.8289 91.4977 70.6297 90.697 70.6297 89.7092V57.2698C70.6296 55.2677 69.9945 53.3154 68.8126 51.6844C67.6307 50.0534 65.9609 48.8247 64.0352 48.1692Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "68.4883",
                y: "5.01758",
                width: "21.0068",
                height: "7.86637",
                rx: "3.93318",
                transform: "rotate(120 68.4883 5.01758)",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.793",
                y: "15.6855",
                width: "21.5633",
                height: "8.07477",
                rx: "4.03738",
                transform: "rotate(56.752 42.793 15.6855)",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.8398",
                y: "34.4297",
                width: "31.6216",
                height: "8.9946",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.SuppBottle = SuppBottle;
//# sourceMappingURL=SuppBottle.cjs.map
